import { ReactNode, SyntheticEvent } from 'react';
import styled from '@emotion/styled';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';

import Button from 'presentations/views/components/atoms/Button';

interface Props {
  open: boolean;
  icon?: ReactNode;
  openIcon?: ReactNode;
  onClick: (e: SyntheticEvent<HTMLButtonElement>) => void;
  className?: string;
}

export default function Component(props: Props) {
  return (
    <StyledButton
      className={props.className}
      onClick={props.onClick}
      color="primary"
    >
      <SpeedDialIcon
        open={props.open}
        icon={props.icon}
        openIcon={props.openIcon}
      />
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  min-width: initial;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
`;
